import { htmlSafe } from '@ember/template';
import { computed } from '@ember/object';
import Component from '@ember/component';
import PRICING_PLANS from 'sh-www/constants/pricing-plans';

export default Component.extend({
  PRICING_PLANS,
  groupedChartData: computed('data', 'chartLabels', 'chartKeyParam', 'groupParam', 'sumParam', function() {
    const labels = this.get('chartLabels');
    const data = this.get('data');
    const groupParam = this.get('groupParam') || 'NULL';
    const sumParam = this.get('sumParam');

    const keyParam = this.get('chartKeyParam');

    return data.reduce((datasets, item) => {
      const group = item.get(groupParam) || 'None';

      if (!datasets[group]) {
        // we need to initialize everything to null to avoid weird graph problems with sparse datasets
        datasets[group] = {};
        Object.keys(labels).forEach(key => {
          datasets[group][key] = null;
        });
      }

      const value = item.get(keyParam);

      if (!datasets[group][value]) {
        datasets[group][value] = 0;
      }
      datasets[group][value] += (sumParam ? item.get(sumParam) : 1);

      return datasets;
    }, {});
  }),

  ////////////////////
  // HELPER METHODS //
  ////////////////////
  formatMoney(total) {
    return (total || total === 0) ?
      total.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      }) :
      '-';
  },

  formatMoneyWithoutChange(total) {
    if (!total && total !== 0) {
      return '-';
    }

    const formatted = this.formatMoney(Math.round(total));
    // substring to remove the change from the dollar amount
    return formatted.substring(0, formatted.length - 3);
  },

  formatDate(date) {
    // Date -> '12/31/2017, 1:45:41 AM' -> ['12/31/2017', '1:45:41 AM'] -> '12/31/2017'
    return date ? date.toLocaleString('en-US').split(',')[0] : '-';
  },

  formatArray(items) {
    return items ? htmlSafe(items.join('<br>')) : '-';
  }
});
